<script>
import { getFreeUserMeetingMinutes } from '@/utils/meeting';

export default {
  name: 'basic-related-tip',
  methods: { getFreeUserMeetingMinutes },
};
</script>

<template>
  <div class="opc-zsched__basic-related-tip">
    {{ $t('billing.scheduler.basic_include_tip', [getFreeUserMeetingMinutes()]) }}
  </div>
</template>

<style scoped lang="scss">
.opc-zsched__basic-related-tip {
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: var(--zoom-color-text-neutral, #686F79);
  margin-top: 16px;
}
</style>
